export function openNav() {
    document.getElementById("navigation-mobile").style.width = "100%";
    document.getElementById("site").style.marginLeft = "100%";
}

export function getLoginUser() {
    const user = JSON.parse(atob(localStorage.getItem('userInfo')))
    return user
}